import React from "react";
import "./Help.css";
import { FaCoffee, FaMoneyBillAlt, FaPercent, FaChild } from "react-icons/fa";

const HelpPricing = () => {
  return (
    <section className="helpSection p-3">
      <div className="container-xl">
        <div className="helpHeader mb-4">
          <h2 className="fw-bold text-dark">Pricing</h2>
          <p className="text-muted">
            Understand what’s included in your stay, how prices are calculated, and any extra charges.
          </p>
        </div>

        <div className="helpContent">
          {/* 1 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaCoffee />
            </div>
            <div className="helpText">
              <h5>Is breakfast included in the price?</h5>
              <p>
                Each room or stay on YOVHO.com has its own breakfast policy. If breakfast is included, it
                will be clearly shown when you view or compare rooms before booking. If it isn’t, check under
                the property’s “Facilities” to see if breakfast is available separately.
              </p>
            </div>
          </div>

          {/* 2 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaMoneyBillAlt />
            </div>
            <div className="helpText">
              <h5>What does the price include?</h5>
              <p>
                The price includes all facilities and services listed under the room type. You’ll also see if
                breakfast, taxes, or service charges are part of the total price before confirming your booking.
              </p>
            </div>
          </div>

          {/* 3 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaPercent />
            </div>
            <div className="helpText">
              <h5>Do I pay any reservation fee or can I use discount coupons?</h5>
              <p>
                YOVHO.com does not charge any booking or reservation fee. Only official YOVHO promotions or
                verified partner discounts can be applied. External coupons or airline/loyalty discounts are not accepted.
              </p>
            </div>
          </div>

          {/* 4 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaChild />
            </div>
            <div className="helpText">
              <h5>Do I pay full price for my child?</h5>
              <p>
                Children’s policies are listed under the “House Rules” before booking. Extra beds or baby cots
                may incur additional charges. You can request them in “Special Requests” during booking or
                contact the property after booking to confirm.
              </p>
            </div>
          </div>

          {/* 5 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaMoneyBillAlt />
            </div>
            <div className="helpText">
              <h5>Are taxes included?</h5>
              <p>
                Taxes depend on the property and type of accommodation. Details are visible before booking
                and included again in your confirmation email.
              </p>
            </div>
          </div>

          {/* 6 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaMoneyBillAlt />
            </div>
            <div className="helpText">
              <h5>What does a crossed-out price mean?</h5>
              <p>
                A crossed-out price shows that the property previously offered higher rates for nearby dates.
                This helps you see verified price drops for your selected stay.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HelpPricing;
